// extracted by mini-css-extract-plugin
export var animationAbsolute = "_2j-q";
export var animationRelative = "_2j-p";
export var backdropBlur = "_2j-0";
export var detailLabelCell = "_2j-12";
export var detailTable = "_2j-11";
export var detailValueCell = "_2j-13";
export var docIconBox = "_2j-1d";
export var docIconBoxMd = "_2j-1f";
export var docIconBoxSm = "_2j-1e";
export var docTypeRow = "_2j-16";
export var docTypeRowInner = "_2j-17";
export var dropdownMatchDatePicker = "_2j-3";
export var evidenceCardContent = "_2j-1c";
export var fileUploadSpin = "_2j-j";
export var gorgiasOpenButton = "_2j-15 _2j-d";
export var gorgiasTicketCard = "_2j-14";
export var heroModalFooterButton = "_2j-18";
export var hiddenContainer = "_2j-o";
export var iconPrimary = "_2j-1g";
export var iconQuaternary = "_2j-1i";
export var iconTertiary = "_2j-1h";
export var integrationCard = "_2j-1";
export var integrationLogoBox = "_2j-2";
export var mainColumnSticky = "_2j-1b";
export var maxWidthContainer = "_2j-19";
export var modalContentBody = "_2j-a";
export var modalHeaderImage = "_2j-5";
export var modalImageLabel = "_2j-7";
export var modalImageOverlay = "_2j-6";
export var modalImageSubtitle = "_2j-9";
export var modalImageTitle = "_2j-8";
export var modalImageWrapper = "_2j-4";
export var modalStickyFooter = "_2j-b";
export var removeButton = "_2j-e";
export var sidebarColumn = "_2j-1a";
export var spinner = "_2j-i";
export var timelineLine = "_2j-y";
export var timelineLineBlack = "_2j-10 _2j-y";
export var timelineLineGray = "_2j-z _2j-y";
export var timelineLineHeight = "_2j-x";
export var tlDotActivate = "_2j-u";
export var tlDotActivateAnim = "_2j-t";
export var tlDotHide = "_2j-s";
export var tlDotHideAnim = "_2j-r";
export var tlLineActivate = "_2j-w";
export var tlLineActivateAnim = "_2j-v";
export var uploadHint = "_2j-n";
export var uploadIconBox = "_2j-k";
export var uploadLabel = "_2j-m";
export var uploadText = "_2j-l";
export var uploadZone = "_2j-f";
export var uploadZoneCursorDefault = "_2j-h";
export var uploadZoneCursorPointer = "_2j-g";
export var uploadedFileRow = "_2j-c";
export var viewButton = "_2j-d";